import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import i18n from "i18next";
import { Link as RouterLink } from "react-router-dom";

import { updateStatusEnum } from "@/utils/enum";

class InformationItem extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="information-item-container">
        {data.readFlag === updateStatusEnum.notUpdate && (
          <div className="information-item-container-read">
            {i18n.t("TCCs0032_information_not_read")}
          </div>
        )}
        <div
          className="information-item-container-date"
          isread={data.readFlag === updateStatusEnum.updated ? "true" : "false"}
        >
          {moment(data.updateDate).format("YYYY.MM.DD")}
        </div>
        <RouterLink
          to={data.detailLink}
          className="information-item-container-title"
        >
          {data.newsTitle}
        </RouterLink>
      </div>
    );
  }
}

InformationItem.propTypes = {
  data: PropTypes.shape({
    newsId: PropTypes.string,
    readFlag: PropTypes.oneOf([
      updateStatusEnum.notUpdate,
      updateStatusEnum.updated,
    ]),
    updateDate: PropTypes.string,
    detailLink: PropTypes.string,
    newsTitle: PropTypes.string,
  }).isRequired,
};

export default InformationItem;
